import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import InputText from 'commons-forms/components/InputText/InputText.jsx';

import FIELD_LENGTH from 'commons-forms/constants/fieldLength.js';

import 'commons-forms/components/InputFormatCurrency/InputFormatCurrency.scss';

class InputFormatCurrency extends React.Component {
    constructor(props) {
        super(props);

        const amountValue =
            this.props.financeValue === '' || Number.isNaN(parseFloat(this.props.financeValue))
                ? 0
                : parseFloat(this.props.financeValue);

        this.currencyFormOptions = {
            currency: 'CAD',
            currencyDisplay: 'symbol',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        };

        this.state = {
            formattedValue: amountValue !== 0 ? LocaleService.l(amountValue, this.currencyFormOptions) : '',
            inputs: {
                input: 0,
            },
            formValidation: {
                input: !this.props.shouldDisplayError,
            },
            showInputFormatted: true,
            displayInputValue: amountValue !== 0 ? amountValue : '',
        };

        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            // TODO : #math.ceil has been removed because of calculator displaying wrong number XX,50
            displayInputValue: parseFloat(newProps.financeValue) !== 0 ? parseFloat(newProps.financeValue) : '',
            formattedValue:
                parseFloat(newProps.financeValue) !== 0
                    ? LocaleService.l(parseFloat(newProps.financeValue), this.currencyFormOptions)
                    : '',
        });
    }

    onInputChange(value) {
        const forceToZero = !this.props.canBeNegative && value < 0;
        const inputValue = forceToZero ? 0 : value.replace(/[^\d-]/g, '');

        const { formValidation, inputs } = this.state;

        if (value > 0 && value !== null && inputs.input !== value && this.props.shouldDisplayError) {
            inputs.input = value;
            formValidation.input = true;
        }

        this.setState({
            formattedValue: inputValue !== 0 ? LocaleService.l(parseFloat(inputValue), this.currencyFormOptions) : '',
            displayInputValue: inputValue !== 0 ? inputValue : '',
            formValidation,
            inputs,
        });
    }

    onBlur() {
        this.setState({
            showInputFormatted: true,
        });
        this.props.onDispatch(parseFloat(this.state.displayInputValue));
    }

    onFocus() {
        if (this.props.onFocus) {
            this.props.onFocus();
        }
        this.setState({
            showInputFormatted: false,
        });
    }

    render() {
        const inputFormatCurrencyClass = ['input-format-currency'];
        inputFormatCurrencyClass.push(this.state.inputClass);

        return (
            <div className={inputFormatCurrencyClass.join(' ')}>
                <InputText
                    type="text"
                    name="InputCurrency"
                    classNames={['styled-placeholder', 'currency', 'dark-theme']}
                    value={this.state.showInputFormatted ? this.state.formattedValue : this.state.displayInputValue}
                    idSuffix={this.props.idSuffix}
                    isValid={this.state.formValidation.input}
                    valueChange={this.onInputChange}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    label={this.props.label}
                    isDisabled={this.props.isDisabled}
                    maxLength={FIELD_LENGTH.DEFAULT_NUMBER_MAX}
                />
            </div>
        );
    }
}

InputFormatCurrency.defaultProps = {
    canBeNegative: true,
    label: '',
    isDisabled: false,
    shouldDisplayError: true,
};

InputFormatCurrency.propTypes = {
    canBeNegative: PropTypes.bool,
    shouldDisplayError: PropTypes.bool,
    financeValue: PropTypes.number.isRequired,
    onDispatch: PropTypes.func.isRequired,
    label: PropTypes.string,
    idSuffix: PropTypes.string,
    isDisabled: PropTypes.bool,
};

InputFormatCurrency.displayName = 'InputFormatCurrency';

export default InputFormatCurrency;
